import React from 'react';
import { useParams } from 'react-router-dom';
import CertificateManagement from 'pages/Common/Tracking/CertificateManagement';

const Tracking = () => {
  const params = useParams();
  const { type } = params;
  return (
    <div>{type === 'certificate-management' && <CertificateManagement/>}</div>
);
};

export default Tracking;
